import { LoginForm } from "components/Common/LoginForm"
import { LoginHeader } from "components/Common/LoginHeader"
import { SignupForm } from "components/Common/SignupForm"
import ErrorPopup from "components/ErrorPopup"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { GET_OTP_RESET } from "../../../redux/types/auth"
import LoginPopup from "components/LoginPopup"
import { useNavigate } from "react-router-dom"
import { LoginTabs } from "components/LoginTabs"
import "./login.scss"
import { LoginFormPvs } from "components/Common/LoginFormPvs"
import PageLoader from "components/Common/PageLoader"
import { useLocation } from "react-router-dom"

const Index = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const {state} = location
  const [isSignup, setIsSignup] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [mobileNumber, setMobileNumber] = useState("")
  const [activeTab, setActiveTab] = useState("otp")
  // const [message, setMessage] = useState("")

  const getOTPScreen = useSelector(state => state.screens.getOTP)
  const loginScreen = useSelector(state => state.screens.login)
  const token = useSelector(state => state.auth.token)
  const user = useSelector(state => state.auth.user)

  const handleSignupClick = () => {
    window.location.href = "./signup"
  }

  useEffect(() => {
    if (token) {
      if (user.user_type === "admin" || user.user_type === "staff") {
        navigate("/dashboard")
      } else {
        navigate("/home")
      }
    }
  }, [])

  // useEffect(() => {
  //   if (getOTPScreen.error) {
  //     dispatch({ type: GET_OTP_RESET })
  //     setMessage(
  //       getOTPScreen.error ||
  //         "An error occurred. Please try again or contact support."
  //     )
  //     setIsOpen(true)
  //   }
  // }, [getOTPScreen])

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  const switchToSignup = mobileNumber => {
    setMobileNumber(mobileNumber)
    setIsSignup(true)
    dispatch({ type: GET_OTP_RESET })
  }

  return (
    <main className="main-container">
      <section className="login-section">
        <div className="login-content">
          <LoginHeader />
          {isSignup ? (
            <SignupForm mobileNumber={mobileNumber} state={state} />
          ) : (
            <>
              <LoginTabs activeTab={activeTab} onTabChange={setActiveTab} />

              <div className="tab-content-container">
                <div
                  className={`tab-content ${
                    activeTab === "pvs" ? "active" : "inactive-right"
                  }`}
                >
                  {activeTab === "pvs" && <LoginFormPvs state={state} />}
                </div>
                <div
                  className={`tab-content ${
                    activeTab === "otp" ? "active" : "inactive-left"
                  }`}
                >
                  {activeTab === "otp" && <LoginForm toggle={toggle} switchToSignup={switchToSignup} state={state} />}
                </div>
              </div>
            </>
            // <LoginForm toggle={toggle} switchToSignup={switchToSignup} />
          )}
          <div className="footer-text mt-3">
            <p>
              <span className="text-muted">
                {isSignup
                  ? "Already have an account? "
                  : "Don't have an account? "}
              </span>
              <button
                onClick={() => setIsSignup(!isSignup)}
                className="register-button"
                type="button"
              >
                {isSignup ? "Login Here" : "Register Here"}
              </button>
            </p>
          </div>

          <footer className="login-footer">
            <div className="help-support-divider">
              <span className="divider-line"></span>
              <span className="divider-text ">HELP & SUPPORT</span>
              <span className="divider-line"></span>
            </div>
            <div className="footer-text">
              <p className="help-text text-muted">
                Need help? &nbsp;
                <a
                  href="https://wa.me/918484832378?text=Hello%20Support%2C%20I%20need%20help%20with%20my%20account"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-link"
                >
                  Contact us on WhatsApp
                </a>
              </p>
            </div>
          </footer>
        </div>
      </section>

      <aside className="image-section">
        <img
          src="https://api.builder.io/api/v1/image/assets/TEMP/e33cdf505f77e0c453b5a5912cdc5f609c0c3ab2?placeholderIfAbsent=true"
          alt="PULA application illustration"
          className="side-image"
        />
      </aside>
      {/* <LoginPopup
        isOpen={isOpen}
        message={message}
        toggle={toggle}
        onConfirm={onConfirm}
        title="PVS not found"
      /> */}
      <PageLoader open={getOTPScreen.loading || loginScreen.loading} />
    </main>
  )
}

export default Index
